import React, { useEffect } from "react";
import styled from "styled-components/macro";
import styles from "../../components/Nav/nav.module.css";
import logo1 from "../../images/TULU_Generator.png";
import { getPrismicItems } from "../../actions/prismicAction";
import { useDispatch } from "react-redux";
import { FormPage } from "../CreateUnit_Form/FormPage";
import Login from "../../components/login";
import { appState, proposal } from "../../globalState";
import { useSnapshot } from "valtio";
import { ReactComponent as ArrowIcon } from "./arrow.svg";
import { ReactComponent as SearchIcon } from "./search.svg";

const CreateUnitForm = () => {
  const [offerName, setOfferName] = React.useState("");
  const [openPicker, setOpenPicker] = React.useState(false);
  const dispatch = useDispatch();
  const appStateSnapshot = useSnapshot(appState);
  useEffect(() => {
    dispatch(getPrismicItems());
  }, [dispatch]);

  return (
    <Login>
      <div>
        <Header>
          <LogoImg
            className={styles.LolinkImg}
            onClick={() => dispatch(getPrismicItems())}
            src={logo1}
            alt="logo"
          />
          <ImportWrapper>
            <SearchIcon style={{ position: "relative", left: 28, top: 14 }} />
            <Input
              autoComplete="off"
              type="text"
              value={offerName}
              placeholder="Search Building"
              name="Import building"
              onChange={(event) => {
                if (event.target.value.length > 0 && !openPicker) {
                  setOpenPicker(true);
                }
                if (!event.target.value.length) {
                  setOpenPicker(false);
                }
                setOfferName(event.target.value);
              }}
            />
            <ArrowIcon
              onClick={() => {
                setOpenPicker(!openPicker);
              }}
              style={{
                transform: `rotate(${openPicker ? "180" : "0"}deg)`,
                transition: "all 0.3s",
                position: "relative",
                right: 22,
                top: 14,
                cursor: "pointer",
              }}
            />

            {openPicker && (
              <Proposals>
                {!appStateSnapshot.savedProposals && "loading..."}

                {appStateSnapshot.savedProposals
                  ?.filter((proposal) =>
                    String(proposal)
                      .toLowerCase()
                      .includes(offerName.toLowerCase())
                  )
                  .map((proposalName) => (
                    <ProposalPicker
                      onClick={() => {
                        setOpenPicker(false);
                        setOfferName(proposalName);
                      }}
                    >
                      {proposalName}
                    </ProposalPicker>
                  ))}
              </Proposals>
            )}
            <ImportButton
              disabled={!offerName}
              onClick={() => {
                setOpenPicker(false);
                proposal.importBuildingName = offerName;
              }}
            >
              Import
            </ImportButton>
          </ImportWrapper>
        </Header>
        <FormPage />
      </div>
    </Login>
  );
};

const ProposalPicker = styled.div`
  pointer: cursor;
  padding-left: 32px;

  &:hover {
    background: #359dc0;
  }
`;

const Proposals = styled.div`
  backdrop-filter: blur(3px);
  position: absolute;
  top: 42px;
  z-index: 10;
  left: 18px;
  height: fit-content;
  max-height: 250px;
  width: 335px;
  background: #ffffffec;
  border: solid 1px grey;
  overflow-y: auto;
`;

const Header = styled.div`
  z-index: 1;
  display: flex;
  justify-content: space-between;
  background-color: #13647b;
  width: 100vw;
  height: 220px;
  padding: 40px 100px 50px 47px;
  margin-bottom: -90px;
`;

const LogoImg = styled.img`
  width: 292.5px;
  height: 48.5px;
`;

const ImportWrapper = styled.a`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: center;
  position: relative;
`;

const Input = styled.input`
  color: #707070;
  padding: 10px;
  padding-left: 32px;

  width: 335px;
  font-family: Manrope, serif;
  border: 1px solid #707070;

  &::-webkit-input-placeholder {
    padding-left: 0.25em;
  }
`;

const ImportButton = styled.a`
  background-color: #050505;
  border: none;
  color: white;
  padding: 11px 22px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  width: fit-content;
  border-radius: 4px;
  margin-left: 10px;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};

  &:hover {
    color: white;
  }
`;

export default CreateUnitForm;
